import {
	ENDPOINT_MY_MAINTENANCE_PLAN,
	ENDPOINT_NEXT_OPERATIONS,
	PARAM_IDENTITYKIT,
	ENDPOINT_ONE_HUB_BACKEND,
	ENDPOINT_UPDATE_MY_KM,
	ENDPOINT_UPDATE_MY_KM_FRAME_PARAM,
	ENDPOINT_UPDATE_MY_KM_FRAME_KMS,
	ENDPOINT_NEW_UNOFFICIAL_OPERATIONS,
	ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_FRAME_PARAM,
	ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_KMS_PARAM,
	ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_DATE_PARAM,
	ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_LOCATION_PARAM,
	ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_ENTRYREASON_PARAM,
} from '../../endpoints';
import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { IEsOnehubVWConfig } from '../models/es-one-hub-config';

export const getNextOperations = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
	userIdentityKit: string,
): Promise<Response> => {
	const endpoint = `${ENDPOINT_MY_MAINTENANCE_PLAN}${ENDPOINT_NEXT_OPERATIONS}`;

	const response = await authServiceInstance.get(
		esOnehubVWConfig.resourceHostId,
		endpoint + '?' + [PARAM_IDENTITYKIT] + '=' + userIdentityKit,
		{
			'Content-Type': 'application/json',
		},
	);

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};

export const getMaintenancePlan = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
): Promise<Response> => {
	const endpoint = `${ENDPOINT_ONE_HUB_BACKEND}${ENDPOINT_MY_MAINTENANCE_PLAN}`;
	const response = await authServiceInstance.get(esOnehubVWConfig.resourceHostId, endpoint, {
		'Content-Type': 'application/json',
	});

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};

export const updateKmApi = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
	userIdentityKit: string,
	frame: string,
	kms: number,
): Promise<Response> => {
	const endpoint = `${ENDPOINT_ONE_HUB_BACKEND}${ENDPOINT_MY_MAINTENANCE_PLAN}${ENDPOINT_UPDATE_MY_KM}`;

	const response = await authServiceInstance.put(
		esOnehubVWConfig.resourceHostId,
		endpoint,
		JSON.stringify({
			[PARAM_IDENTITYKIT]: userIdentityKit,
			[ENDPOINT_UPDATE_MY_KM_FRAME_PARAM]: frame,
			[ENDPOINT_UPDATE_MY_KM_FRAME_KMS]: kms,
		}),
	);

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};

export const newUnofficialOperation = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
	userIdentityKit: string,
	frame: string,
	kms: number,
	date: Date,
	location: string,
	entryReason: string,
): Promise<Response> => {
	const endpoint = `${ENDPOINT_ONE_HUB_BACKEND}${ENDPOINT_MY_MAINTENANCE_PLAN}${ENDPOINT_NEW_UNOFFICIAL_OPERATIONS}`;

	const response = await authServiceInstance.post(
		esOnehubVWConfig.resourceHostId,
		endpoint,
		JSON.stringify({
			[PARAM_IDENTITYKIT]: userIdentityKit,
			[ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_FRAME_PARAM]: frame,
			[ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_KMS_PARAM]: kms,
			[ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_DATE_PARAM]: date,
			[ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_LOCATION_PARAM]: location,
			[ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_ENTRYREASON_PARAM]: entryReason,
		}),
	);

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};
